import * as React from "react";
import { Text } from "@uikit";
import { CheckCircleIcon } from "@heroicons/react/solid";
import { FaCircleNotch } from "@react-icons/all-files/fa/FaCircleNotch";

interface IProps {
  tags: string[];
}
const MailingListSignup = ({ tags }: IProps) => {
  const [email, setEmail] = React.useState("");
  const [processing, setProcessing] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setProcessing(true);

    const response = await fetch(
      "https://zuphopurmhhmbxukmffg.supabase.co/functions/v1/add-to-mailinglist",
      {
        method: "POST",
        headers: {
          Accept: "application.json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          tags: tags,
        }),
      }
    );

    const data = await response.json();

    if (data) {
      setEmail("");
      setSubmitted(true);
      setProcessing(false);
      setTimeout(() => {
        setSubmitted(false);
      }, 10000);
    } else {
      alert("Something went wrong, please try again");
      setProcessing(false);
    }
  };
  return (
    <div className="bg-blue py-7 sm:py-7 sm:px-[0px] flex justify-center">
      <div className="lg:max-w-[1000px] xl:max-w-[1120px] mx-auto px-[20px] md:px-10 lg:px-0 flex flex-col sm:flex-row flex-1 justify-between  items-center gap-5">
        <div className="flex flex-1 col-span-12 md:col-span-6">
          <Text
            size={17}
            weight="semibold"
            color="white"
            leading={1.3}
            className="text-left md:mb-0"
          >
            Join our mailing list to get unbeatable golf deals in your inbox
          </Text>
        </div>
        {submitted ? (
          <div className="h-[42px] flex items-center w-full sm:w-auto">
            <Text
              size={17}
              weight="semibold"
              color="orange"
              leading={1.3}
              className="text-left md:mb-0"
            >
              <span className="flex items-center gap-1">
                <CheckCircleIcon className="w-6 text-orange" />
                Thanks for signing up!
              </span>
            </Text>
          </div>
        ) : (
          <form
            className="w-full flex flex-1 col-span-12 md:col-span-6"
            onSubmit={handleSubmit}
          >
            <label htmlFor="email-address" className="sr-only">
              Email address
            </label>
            <input
              type="email"
              name="email-address"
              id="email-address"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="appearance-none min-w-0 w-full bg-white py-2 px-4 text-base rounded-r-none rounded-md text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-none border-none"
              placeholder="Enter your email address"
            />
            <div className={` rounded-md rounded-l-none  bg-white p-[6px]`}>
              <button
                disabled={processing}
                type="submit"
                className={` ${processing ? "bg-red/50" : "bg-red"}
                w-full border border-transparent rounded-[4px] py-1 px-4 flex items-center justify-center text-sm font-medium text-white focus:outline-none focus:ring-0 }`}
              >
                Subscribe
                {processing && (
                  <FaCircleNotch className="h-4 w-4 animate-spin ml-1" />
                )}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};
export default MailingListSignup;
